import { useEffect } from "react";
import { GLOBAL_DATA_REFRESH_EVENT } from "utils/globalSubscriptionEvents";

/**
 * Listen for globalsubscribe-driven refresh events on the web app.
 *
 * @param {string|string[]} messageTypes - e.g. "task", ["mission", "missionid"]
 * @param {(detail: object) => void} onRefresh
 */
export default function useGlobalDataRefresh(messageTypes, onRefresh) {
  useEffect(() => {
    if (!onRefresh) return undefined;

    const types = new Set(
      (Array.isArray(messageTypes) ? messageTypes : [messageTypes]).map((t) =>
        String(t).trim().toLowerCase().replace(/[\s_-]+/g, ""),
      ),
    );

    const handler = (event) => {
      const detail = event?.detail;
      if (!detail || !types.has(detail.messageType)) return;
      onRefresh(detail);
    };

    window.addEventListener(GLOBAL_DATA_REFRESH_EVENT, handler);
    return () => window.removeEventListener(GLOBAL_DATA_REFRESH_EVENT, handler);
  }, [messageTypes, onRefresh]);
}
